import * as React from 'react';
import Box from '@mui/material/Box';
import { options } from '@config';
import Loading from '../../../../auxiliares/loading';
import ConfiguracionUser from './profileContent';

export default function UserDetailContainer () {


    const userId = localStorage.getItem("CLUB-VIP-USER")

    const [items, setItems] = React.useState([]);
    const [loading, setLoading] = React.useState(true); 
    const handleListUsers = async () => {
        const response = await fetch((options.api.url + "user"), {
            method: 'GET',
            mode: "cors",
            headers: {
                'Content-Type': 'application/json'
            },
            // body: JSON.stringify({ uid }),
        })
        const data = await response.json();
        const usersTable = data.usersSearched
        const items = usersTable.find((row) => row.user === userId);
        return items
    }

    React.useEffect(()=> {
        const db = handleListUsers().then((e) => {
            setItems(e);
            setLoading(false);
        });
    },[loading]);

    return (
        <Box>
            {loading ? <Loading/>: <ConfiguracionUser items={items}/>}
        </Box>
    )
}
